import { useNavigate, useParams } from "react-router";

import type { PATHS } from "@/routes/paths";

import type { ParamParseKey } from "react-router";

export const useGetPlanStockPageParams = () => {
	const { hotelID } = useParams<ParamParseKey<typeof PATHS.HOTEL.ITEMS.PLAN.STOCK>>();

	const navigate = useNavigate();
	if (!hotelID) {
		navigate("/");
	}

	return {
		hotelID: hotelID!,
	};
};
